<template>
  <div class="template-library">
    <!-- 搜索表单 -->
    <div class="search-form-wrapper">
      <div class="search-form">
        <div class="search-item">
          <label>标题:</label>
          <el-input v-model="searchForm.text" placeholder="请输入标题" clearable @keyup.enter.native="handleSearch"
            @clear="handleClear"></el-input>
        </div>
        <div class="search-item">
          <label>标签:</label>
          <el-select v-model="searchForm.tagIds" placeholder="请选择标签" clearable filterable>
            <el-option v-for="tag in tagOptions" :key="tag.value" :label="tag.label" :value="tag.value"></el-option>
          </el-select>
        </div>
        <div class="search-item">
          <label>发布人:</label>
          <el-select v-model="searchForm.publisherIds" placeholder="请选择发布人" clearable filterable>
            <el-option v-for="publisher in publisherOptions" :key="publisher.value" :label="publisher.label"
              :value="publisher.value"></el-option>
          </el-select>
        </div>
        <div class="search-item">
          <label>模版类型:</label>
          <el-select v-model="searchForm.type" placeholder="请选择模版类型" clearable>
            <el-option label="全本模版" :value="1"></el-option>
            <el-option label="纸张模版" :value="2"></el-option>
            <el-option label="封面模版" :value="3"></el-option>
          </el-select>
        </div>
        <div class="search-item">
          <label>资料类型:</label>
          <el-select v-model="searchForm.paymentType" placeholder="请选择资料类型" clearable>
            <el-option label="免费" value="FREE"></el-option>
            <el-option label="付费" value="PREMIUM"></el-option>
            <el-option label="Pro会员领取" value="VIP_PRO"></el-option>
          </el-select>
        </div>
        <div class="search-item">
          <label>状态:</label>
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="待上架" :value="0"></el-option>
            <el-option label="已上架" :value="1"></el-option>
            <el-option label="已下架" :value="2"></el-option>
            <el-option label="已永久移除" :value="3"></el-option>
          </el-select>
        </div>
        <div class="search-item">
          <label>排序:</label>
          <el-select v-model="searchForm.customSort" placeholder="请选择排序" clearable>
            <el-option label="按添加时间（近-远）" value="createdAt#desc"></el-option>
            <el-option label="按添加时间（远-近）" value="createdAt#asc"></el-option>
            <el-option label="按真实创建量（降序）" value="realUsageCount#desc"></el-option>
            <el-option label="按真实创建量（升序）" value="realUsageCount#asc"></el-option>
          </el-select>
        </div>
        <div class="search-buttons">
          <el-button @click="handleClear">清空</el-button>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button type="primary" @click="toUploadData()">
            上传模版素材
          </el-button>
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <div class="table-main" ref="tableMain">
        <el-table
          :data="formattedTableData"
          border
          size="small"
          style="width: 100%"
          :height="tableHeight"
          :header-cell-style="{ background: '#f7f7f7', fontWeight: 500, textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
        >
          <el-table-column type="index" label="No" width="50" align="center">
            <template slot-scope="scope">
              {{ (params.page - 1) * params.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="id" label="模版id" width="100" align="center" show-overflow-tooltip />
          <el-table-column prop="type" label="模版类型" width="110" align="center" show-overflow-tooltip />
          <el-table-column prop="thumbnail" label="缩略图" width="110" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.thumbnail"
                :src="scope.row.thumbnail"
                fit="fill"
                :preview-src-list="[scope.row.thumbnail]"
                style="width: 80px; height: 60px; border-radius: 4px;"
              />
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="thumbnailBadge" label="缩略图角标" width="110" align="center" show-overflow-tooltip />
          <el-table-column prop="title" label="标题" width="180" align="center" show-overflow-tooltip />
          <el-table-column prop="tags" label="标签" width="200" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.tags && scope.row.tags.length" class="tags-cell">
                <div
                  v-for="(t, tIndex) in scope.row.tags"
                  :key="t && t.id ? t.id : tIndex"
                  class="tag-pill"
                  :title="t && t.name ? t.name : t"
                >
                  {{ t && t.name ? t.name : t }}
                </div>
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="slogan" label="适用设备" width="120" align="center" show-overflow-tooltip />
          <el-table-column prop="realUsageCount" label="真实创建量" width="110" align="center" show-overflow-tooltip />
          <el-table-column prop="publisherName" label="发布人" width="130" align="center" show-overflow-tooltip />
          <el-table-column prop="buttonBadge" label="按钮角标" width="110" align="center" show-overflow-tooltip />
          <el-table-column prop="paymentType" label="资料类型" width="110" align="center" show-overflow-tooltip />
          <el-table-column prop="price" label="原价" width="100" align="center" show-overflow-tooltip />
          <el-table-column prop="price1" label="常规折扣价" width="120" align="center" show-overflow-tooltip />
          <el-table-column prop="price2" label="文星会员折扣价" width="150" align="center" show-overflow-tooltip />
          <el-table-column prop="price3" label="Pro会员折扣价" width="140" align="center" show-overflow-tooltip />
          <el-table-column prop="status" label="状态" width="100" align="center" show-overflow-tooltip />
          <el-table-column label="操作" width="300" align="center" fixed="right">
            <template slot-scope="scope">
              <span class="checkDetailsBtn" @click="onRowAction('编辑', scope.row)">编辑</span>
              <span
                :class="getStatusBtnClass(scope.row.statusCode)"
                @click="onRowAction('状态', scope.row)"
              >{{ scope.row.statusBtnText }}</span>
              <span class="checkDetailsBtn" @click="onRowAction('测试', scope.row)">测试</span>
              <span class="checkDetailsBtn" @click="onRowAction('复制链接', scope.row)">复制链接</span>
              <span class="checkDetailsBtn" @click="onRowAction('操作详情', scope.row)">操作详情</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrapper">
        <pagination :currentPage="params.page" :pageSize="params.pageSize" :total="total" @pageNum="getPageNum" />
      </div>
    </div>

    <!-- 上传/编辑模版对话框 -->
    <el-dialog title="上传模版素材" :visible.sync="uploadVisible" fullscreen :close-on-click-modal="false"
      :close-on-press-escape="false" :destroy-on-close="true" :lock-scroll="true" custom-class="upload-data-dialog">
      <upload-data :detailId="detailId" @success="handleUploadSuccess" />
    </el-dialog>

    <!-- 操作详情 -->
    <el-dialog title="操作详情" :visible.sync="optRecordVisible" fullscreen custom-class="add-material-dialog"
      :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <opt-record :detailId="detailId" />
    </el-dialog>

    <!-- 测试对话框 -->
    <el-dialog title="测试" :visible.sync="testVisible" width="500px">
      <test @confirm="testConfirm" @close="testVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
import UploadData from "./components/uploadData/index.vue";
import OptRecord from "./components/optRecord/index.vue";
import Test from "@/components/Test.vue";
import api from "@/api";
import { valueByLanguage } from "@/utils/college";

const TemplateTypeMap = {
  1: "全本模版",
  2: "纸张模版",
  3: "封面模版"
};

const ShelfStatusMap = {
  0: "待上架",
  1: "已上架",
  2: "已下架",
  3: "已永久移除"
};

const ShelfStatusBtnMap = {
  0: "上架",
  1: "下架",
  2: "彻底下架",
  3: "已彻底下架"
};

const PaymentTypeMap = {
  FREE: "免费",
  PREMIUM: "付费",
  VIP_PRO: "Pro会员领取"
};

export default {
  name: "TemplateLibrary",
  components: {
    pagination,
    UploadData,
    OptRecord,
    Test
  },
  mixins: [listMixin],
  data() {
    return {
      tableHeight: 400,
      params: {
        page: 1,
        pageSize: 20
      },
      searchForm: {
        text: "",
        tagIds: null,
        publisherIds: null,
        type: null,
        paymentType: null,
        status: null,
        customSort: null
      },
      tableData: [],
      total: 0,
      loading: false,
      uploadVisible: false,
      optRecordVisible: false,
      testVisible: false,
      detailId: null,
      tagOptions: [],
      publisherOptions: []
    };
  },
  computed: {
    formattedTableData() {
      return this.tableData.map((row) => {
        const thumbnail = valueByLanguage(row.thumbnail, "zh_CN", true);
        const thumbnailBadge = valueByLanguage(row.thumbnailBadge, "zh_CN", true);
        const title = valueByLanguage(row.title, "zh_CN", true);
        const slogan = valueByLanguage(row.slogan, "zh_CN", true);
        const buttonBadge = valueByLanguage(row.buttonBadge, "zh_CN", true);
        const publisherName = row.publisher
          ? (valueByLanguage(row.publisher.name, "zh_CN", true) || row.publisher.name || "-")
          : "-";

        // 标签：与贴纸库一致，保证 tags 为数组，每项的 name 为简体中文字符串
        // console.log(row.tags);
        const tags = Array.isArray(row.tags)
          ? row.tags
            .map((tag) => {
              if (!tag) return null;
              const rawName = (() => {
                if (!tag.name) return "";
                if (Array.isArray(tag.name)) {
                  return valueByLanguage(tag.name, "zh_CN", true) || "";
                }
                return String(tag.name || "");
              })();
              if (!rawName || !rawName.trim()) return null;
              return {
                ...tag,
                name: rawName
              };
            })
            .filter((t) => t !== null)
          : [];

        const paymentInfo = row.paymentInfo || {};
        const paymentType = paymentInfo.type;

        return {
          ...row,
          thumbnail: thumbnail || "",
          thumbnailBadge: thumbnailBadge || "-",
          title: title || "-",
          type: TemplateTypeMap[row.type] || "-",
          tags: tags,
          slogan: slogan || "-",
          publisherName: publisherName,
          buttonBadge: buttonBadge || "-",
          paymentType: PaymentTypeMap[paymentType] || "-",
          price:
            paymentInfo.price !== null && paymentInfo.price !== undefined
              ? (paymentInfo.price / 100).toFixed(2)
              : "-",
          price1:
            paymentInfo.price1 !== null && paymentInfo.price1 !== undefined
              ? (paymentInfo.price1 / 100).toFixed(2)
              : "-",
          price2:
            paymentInfo.price2 !== null && paymentInfo.price2 !== undefined
              ? (paymentInfo.price2 / 100).toFixed(2)
              : "-",
          price3:
            paymentInfo.price3 !== null && paymentInfo.price3 !== undefined
              ? (paymentInfo.price3 / 100).toFixed(2)
              : "-",
          status: ShelfStatusMap[row.status] || "未知",
          statusCode: row.status,
          statusBtnText: ShelfStatusBtnMap[row.status] || "状态"
        };
      });
    }
  },
  mounted() {
    this.updateTableHeight();
    window.addEventListener("resize", this.updateTableHeight);
    this.loadTagOptions();
    this.loadPublisherOptions();
    this.getList();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableHeight);
  },
  methods: {
    updateTableHeight() {
      this.$nextTick(() => {
        const el = this.$refs.tableMain;
        if (el && el.clientHeight) {
          this.tableHeight = el.clientHeight;
        }
      });
    },
    getList() {
      this.loading = true;
      api
        .getTemplateList(this.params)
        .then((res) => {
          this.tableData = res.data.items || [];
          this.total = res.data.count || 0;
          this.loading = false;
          this.updateTableHeight();
        })
        .catch((err) => {
          this.$message.error(err.message || "获取列表失败");
          this.loading = false;
        });
    },
    handleSearch() {
      this.params = {
        page: 1,
        pageSize: 20
      };

      if (this.searchForm.text) {
        this.params.text = this.searchForm.text;
      }
      if (this.searchForm.tagIds) {
        this.params.tagIds = Array.isArray(this.searchForm.tagIds)
          ? this.searchForm.tagIds
          : [this.searchForm.tagIds];
      }
      if (this.searchForm.publisherIds) {
        this.params.publisherIds = Array.isArray(this.searchForm.publisherIds)
          ? this.searchForm.publisherIds
          : [this.searchForm.publisherIds];
      }
      if (this.searchForm.type !== null && this.searchForm.type !== undefined) {
        this.params.type = this.searchForm.type;
      }
      if (this.searchForm.paymentType) {
        this.params.paymentType = this.searchForm.paymentType;
      }
      if (this.searchForm.status !== null && this.searchForm.status !== undefined) {
        this.params.status = this.searchForm.status;
      }
      if (this.searchForm.customSort) {
        const [sortBy, orderBy] = this.searchForm.customSort.split("#");
        if (sortBy && orderBy) {
          this.params.sortBy = sortBy;
          this.params.orderBy = orderBy;
        }
      }

      this.getList();
    },
    handleClear() {
      this.searchForm = {
        text: "",
        tagIds: null,
        publisherIds: null,
        type: null,
        paymentType: null,
        status: null,
        customSort: null
      };
      this.params = {
        page: 1,
        pageSize: 20
      };
      this.getList();
    },
    loadTagOptions() {
      api
        .getMaterialTagList({ page: 1, pageSize: 1000 })
        .then((res) => {
          this.tagOptions = (res.data.items || []).map((item) => {
            const nameObj = valueByLanguage(item.name, "zh_CN", true);
            return {
              label: nameObj || "-",
              value: item.id
            };
          });
        })
        .catch(() => { });
    },
    loadPublisherOptions() {
      api
        .getMaterialPublisherList({ page: 1, pageSize: 1000 })
        .then((res) => {
          this.publisherOptions = (res.data.items || []).map((item) => {
            const nameObj = valueByLanguage(item.name, "zh_CN", true);
            return {
              label: nameObj || "-",
              value: item.id
            };
          });
        })
        .catch(() => { });
    },
    getPageNum(page) {
      this.params.page = page;
      this.getList();
    },
    getStatusBtnClass(status) {
      const statusColorMap = {
        0: "checkDetailsBtn success-btn",
        1: "checkDetailsBtn danger-btn",
        2: "checkDetailsBtn danger-btn",
        3: "checkDetailsBtn info-btn"
      };
      return statusColorMap[status] || "checkDetailsBtn";
    },
    onRowAction(type, row) {
      this.tableHandle({ type, data: { row } });
    },
    tableHandle(data) {
      const row = data.data && data.data.row ? data.data.row : data.row;

      if (data.type === "编辑") {
        if (row && row.id) {
          const originalItem = this.tableData.find((item) => item && item.id === row.id);
          if (originalItem) {
            this.toUploadData(originalItem);
          }
        }
      } else if (data.type === "状态") {
        if (row && row.id) {
          const originalItem = this.tableData.find((item) => item && item.id === row.id);
          if (originalItem) {
            this.updateShelfStatus(originalItem);
          }
        }
      } else if (data.type === "测试") {
        if (row && row.id) {
          const originalItem = this.tableData.find((item) => item && item.id === row.id);
          if (originalItem) {
            this.openTest(originalItem);
          }
        }
      } else if (data.type === "复制链接") {
        if (row && row.id) {
          const originalItem = this.tableData.find((item) => item && item.id === row.id);
          if (originalItem) {
            this.copyLink(originalItem);
          }
        }
      } else if (data.type === "操作详情") {
        if (row && row.id) {
          this.openOptRecord(row);
        }
      }
    },
    toUploadData(row) {
      this.detailId = row ? row.id : null;
      this.uploadVisible = true;
    },
    updateShelfStatus(row) {
      if (row.status === 3) {
        this.$message.warning("已永久移除，无法修改状态");
        return;
      }
      const statusMap = {
        0: 1,
        1: 2,
        2: 3
      };
      const newStatus = statusMap[row.status];
      if (newStatus === undefined) {
        this.$message.warning("无法修改状态");
        return;
      }
      api
        .updateTemplateStatus(row.id, { status: newStatus })
        .then(() => {
          this.$message.success("状态更新成功");
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err.message || "状态更新失败");
        });
    },
    openOptRecord(row) {
      this.detailId = row.id;
      this.optRecordVisible = true;
    },
    copyLink(row) {
      const url = `${window.location.origin}/library/material/detail?id=${row.uniqueId}&lang=zh&type=TEMPLATE`;
      const textarea = document.createElement("textarea");
      textarea.value = url;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        this.$message.success("复制成功，请在浏览器粘贴");
      } catch (err) {
        this.$message.error("复制失败");
      }
      document.body.removeChild(textarea);
    },
    openTest(row) {
      this.detailId = row.id;
      this.testVisible = true;
    },
    testConfirm(data) {
      api
        .testTemplate(this.detailId, data)
        .then(() => {
          this.$message.success("测试成功");
          this.testVisible = false;
        })
        .catch((err) => {
          this.$message.error(err.message || "测试失败");
        });
    },
    handleUploadSuccess() {
      this.uploadVisible = false;
      this.detailId = null;
      this.getList();
    }
  }
};
</script>

<style scoped>
.template-library {
  height: 100%;
  min-width: 0;
  padding: 16px;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search-form-wrapper {
  flex-shrink: 0;
  margin-bottom: 20px;
}

.search-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-item label {
  white-space: nowrap;
  margin-right: 4px;
}

.search-item :deep(.el-input),
.search-item :deep(.el-select) {
  width: 200px;
}

.search-buttons {
  display: flex;
  gap: 10px;
  margin-left: auto;
}

.table-wrapper {
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-main {
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

/* 原生滚条样式，不覆盖 fixed 相关 overflow，避免再把横滚搞没 */
.table-main :deep(.el-table__body-wrapper) {
  scrollbar-width: thin;
  scrollbar-color: #909399 #e4e7ed;
}

.table-main :deep(.el-table__body-wrapper)::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.table-main :deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb {
  background: #909399;
  border-radius: 5px;
}

.table-main :deep(.el-table__body-wrapper)::-webkit-scrollbar-track {
  background: #e4e7ed;
}

.tags-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  width: 100%;
  overflow: hidden;
}

.tag-pill {
  color: #67c23a;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  padding: 0 6px;
  max-width: 85px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.success-btn {
  color: #67c23a !important;
}

.danger-btn {
  color: #f56c6c !important;
}

.info-btn {
  color: #909399 !important;
}

.pagination-wrapper {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

:deep(.upload-data-dialog.el-dialog .el-dialog__body) {
  padding: 16px;
}

:deep(.add-material-dialog.el-dialog) {
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin: 0;
}

:deep(.add-material-dialog.el-dialog .el-dialog__header) {
  flex-shrink: 0;
}

:deep(.add-material-dialog.el-dialog .el-dialog__body) {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

:deep(.add-material-dialog.el-dialog .el-dialog__body > .opt-record) {
  flex: 1;
  min-height: 0;
}
</style>
